import {version} from './package.json'

export default {
	hostname: process.env.NODE_ENV === 'development' ? '' : 'https://tb.co.th',
	/* server: {
		port: 3000,
		host: '0.0.0.0'
	}, */
	env: {
		firestore: {
			config: 'configs/app'
		},
		pages: {
			'404': {
				title: 'ไม่พบหน้าที่ต้องการ',
				description: 'ไม่พบหน้าที่ต้องการ'
			},
			details: {
				title: 'ข้อมูลประกาศขาย/เช่า อสังหาริมทรัพย์',
				description: 'ข้อมูลประกาศขาย/เช่า อสังหาริมทรัพย์ มีระบบแผนที่ใช้ดูสถานที่ใกล้เคียง และ สามารถเช็ควงเงินกู้ได้ทันที พร้อมบริการจัดสินเชื่อให้อีกด้วย'
			},
			index: {
				title: 'The Best Property : ขายบ้าน คอนโด ที่ดิน อสังหาฯทุกประเภท',
				description: 'ตัวแทน ซื้อ ขาย เช่า บ้านเดี่ยว ทาวน์เฮ้าส์ คอนโด ที่ดิน โกดังโรงงาน อพาร์ทเม้นท์ ฯลฯ ในประเทศไทย The Best Property ผู้นำด้านการซื้อขาย บ้าน ที่ดิน อสังหาริมทรัพย์ทุกประเภท พร้อมบริการจัดสินเชื่อ'
			},
			map: {
				title: 'ค้นหาจากแผนที่ ประกาศขาย บ้าน คอนโด ที่ดิน อสังหาฯ',
				description: 'ค้นหาประกาศขายอสังหาริมทรัพย์ทุกประเภท ในประเทศไทย ค้นหาเจอง่าย ดูจากแผนที่ Google Map รูปชัด ข้อมูลครบถ้วน อัพเดทใหม่ทุกวัน เช็ควงเงินกู้ได้ทันที พร้อมบริการจัดสินเชื่อให้อีกด้วย'
			},
			search: {
				title: 'รวมประกาศขาย บ้าน คอนโด ที่ดิน อสังหาฯ ในประเทศไทย',
				description: 'ค้นหาประกาศขายอสังหาริมทรัพย์ทุกประเภท ในประเทศไทย ค้นหาเจอง่าย ดูจากแผนที่ Google Map รูปชัด ข้อมูลครบถ้วน อัพเดทใหม่ทุกวัน เช็ควงเงินกู้ได้ทันที พร้อมบริการจัดสินเชื่อให้อีกด้วย'
			},
			agent: {
				title: 'ตัวแทน The Best Property',
				description: 'ตัวแทนขายอสังหาริมทรัพย์บริษัท The Best Property Agent เป็นตัวแทนมืออาชีพที่มีประสบการณ์ การันตีด้วยผลงานการขาย พร้อมให้บริการ รับฝากขาย รับฝากเช่า อสังหาริมทรัพย์ ทุกประเภท บริการด้วยใจ เราคือผู้นำด้านการขายอสังหาริมทรัพย์ เราจะค้นหาเพื่อส่งมอบสิ่งที่ดีที่สุดให้กับลูกค้า'
			},
			agentRegister: {
				title: 'สมัครตัวแทน The Best Property',
				description: 'ตัวแทนขายอสังหาริมทรัพย์บริษัท The Best Property Agent เป็นตัวแทนมืออาชีพที่มีประสบการณ์ การันตีด้วยผลงานการขาย พร้อมให้บริการ รับฝากขาย รับฝากเช่า อสังหาริมทรัพย์ ทุกประเภท บริการด้วยใจ เราคือผู้นำด้านการขายอสังหาริมทรัพย์ เราจะค้นหาเพื่อส่งมอบสิ่งที่ดีที่สุดให้กับลูกค้า'
			},
			guestRegister: {
				title: 'เข้าฟังฟรี! Instant Intro The Best Property Agent',
				description: 'ตัวแทนขายอสังหาริมทรัพย์บริษัท The Best Property Agent เป็นตัวแทนมืออาชีพที่มีประสบการณ์ การันตีด้วยผลงานการขาย พร้อมให้บริการ รับฝากขาย รับฝากเช่า อสังหาริมทรัพย์ ทุกประเภท บริการด้วยใจ เราคือผู้นำด้านการขายอสังหาริมทรัพย์ เราจะค้นหาเพื่อส่งมอบสิ่งที่ดีที่สุดให้กับลูกค้า',
				meta: [
					{ hid: 'robots', name: 'robots', content: 'noindex' },
				]
			},
			agentDetail: {
				title: 'ข้อมูลตัวแทน',
				description: 'ข้อมูลตัวแทน'
			},
			portfolio: {
				title: 'ผลงานของเรา',
				description: 'ผลงานของเรา'
			},
			coupon: {
				title: 'ลงทะเบียนผู้ซื้อ',
				description: 'ลงทะเบียนผู้ซื้อ'
			},
			customerContract: {
				title: 'ลงทะเบียนผู้ขาย',
				description: 'ลงทะเบียนผู้ขาย'
			},
			blog_review: {
				title: 'รวมรีวิวอสังหาริมทรัพย์ในประเทศไทย อัปเดตล่าสุด 2025 - the best',
				description: 'อัปเดตข่าวสาร รวม รีวิวอสังหาริมทรัพย์ บ้าน คอนโด ทาวน์โฮม ทาวน์เฮ้าส์ ทำเลที่ดีที่สุด โครงการไหนน่าอยู่  สิ่งอำนวยความสะดวกพร้อม'
			},
			contact: {
				title: 'รวมรีวิวอสังหาริมทรัพย์ในประเทศไทย อัปเดตล่าสุด 2025 - the best',
				description: 'อัปเดตข่าวสาร รวม รีวิวอสังหาริมทรัพย์ บ้าน คอนโด ทาวน์โฮม ทาวน์เฮ้าส์ ทำเลที่ดีที่สุด โครงการไหนน่าอยู่  สิ่งอำนวยความสะดวกพร้อม'
			},
			privacyPolicy: {
				title: 'รวมรีวิวอสังหาริมทรัพย์ในประเทศไทย อัปเดตล่าสุด 2025 - the best',
				description: 'อัปเดตข่าวสาร รวม รีวิวอสังหาริมทรัพย์ บ้าน คอนโด ทาวน์โฮม ทาวน์เฮ้าส์ ทำเลที่ดีที่สุด โครงการไหนน่าอยู่  สิ่งอำนวยความสะดวกพร้อม'
			},
			termsAndConditions: {
				title: 'รวมรีวิวอสังหาริมทรัพย์ในประเทศไทย อัปเดตล่าสุด 2025 - the best',
				description: 'อัปเดตข่าวสาร รวม รีวิวอสังหาริมทรัพย์ บ้าน คอนโด ทาวน์โฮม ทาวน์เฮ้าส์ ทำเลที่ดีที่สุด โครงการไหนน่าอยู่  สิ่งอำนวยความสะดวกพร้อม'
			}
		},
		apiURL: 'https://api.tb.co.th/api' // 'http://127.0.0.1:8000/api' //
	},
	// mode: 'universal',
	/*
	 ** Headers of the page
	 */
	head: {
		meta: [
			{ charset: 'utf-8' },
			{
				name: 'viewport',
				// content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
				content: 'width=device-width, initial-scale=1.0, maximum-scale=3.0'
			},
			{
				name: 'author',
				content: 'MakeZone CO., LTD. (https://makezone.co.th)'
			},
			{ name: 'msapplication-TileColor', content: '#da3732' },
			{ name: 'theme-color', content: '#ffffff' }
		],
		link: [
			{ rel: 'dns-prefetch', href: '//fonts.gstatic.com' },
			{ rel: 'preconnect', href: '/' },
			// { rel: 'preconnect', href: '//fonts.googleapis.com' },
			{ rel: 'preconnect', href: '//cdn.jsdelivr.net' },
			// { rel: 'preconnect', href: '//stats.g.doubleclick.net' },
			{
				rel: 'apple-touch-icon',
				type: 'image/x-icon',
				sizes: '180x180',
				href: '/apple-touch-icon.png'
			},
			{
				rel: 'icon',
				type: 'image/png',
				sizes: '32x32',
				href: '/favicon-32x32.png'
			},
			{
				rel: 'icon',
				type: 'image/png',
				sizes: '16x16',
				href: '/favicon-16x16.png'
			},
			{ rel: 'manifest', href: '/site.webmanifest' },
			{
				rel: 'mask-icon',
				color: '#da3732',
				href: '/safari-pinned-tab.svg'
			},
			{
				rel: 'stylesheet',
				// rel: 'preconnect',
				type: 'text/css',
				href: 'https://fonts.googleapis.com/css?family=Material+Icons', // 'https://fonts.googleapis.com/css?family=Kanit|Material+Icons'
				body: true
			},
			// {
			// 	rel: 'stylesheet',
			// 	// rel: 'preconnect',
			// 	type: 'text/css',
			// 	href: '/css/mdi/materialdesignicons.min.css',
			// 	body: true
			// },
		],
		script: [
			// {
			// 	type: 'text/javascript',
			// 	async: '',
			// 	src: 'https://www.googletagmanager.com/gtag/js?id=G-JF62M826QS'
			// },
			{
				src: '/js/social_external.js?v=3',
				async: true,
				body: true
			},
			// {
			// 	src: '/js/jquery-1.11.1.min.js',
			// 	async: true,
			// 	body: true
			// },
			// {
			// 	src: '/js/fotorama-4.6.4.min.js',
			// 	async: true,
			// 	body: true
			// }
		]
	},
	/*
	 ** Customize the progress-bar color
	 */
	loading: {
		color: '#ffffffee',
		height: '3px',
		throttle: 0
	},
	/*
	 ** Global CSS
	 */
	css: ['@assets/scss/main.scss'],
	/*
	 ** Plugins to load before mounting the App
	 */
	plugins: [
		'~/plugins/components',
		'~/plugins/config-search',
		{ src: '~/plugins/google-maps', mode: 'client' },
		{ src: '~/plugins/md5', mode: 'client' },
		{ src: '~/plugins/local-storage', mode: 'client' },
		{ src: '~/plugins/image-resize', mode: 'client' },
		'~/plugins/number-format',
		{ src: '~/plugins/router-helper' /*, mode: 'client' */ },
		'~/plugins/time-ago',
		'~/plugins/gtm',
		{ src: '~/plugins/country-list', mode: 'client' },
		{ src: '~/plugins/multiple-download', mode: 'client' },
	],
	serverMiddleware: [
		'~/server-middleware/redirects',
	],
	// redirect: [
	// 	{ from: '^/samut-prakan/single-house', to: '/samut-prakan/singlehome', statusCode: 301 },
	// 	{ from: '^/samut-prakan/srinakarin', to: '/samut-prakan/singlehome/srinakarin', statusCode: 301 },
	// 	{ from: '^/samut-prakan/thepharak', to: '/samut-prakan/singlehome/thepharak', statusCode: 301 },
	// 	{ from: '^/samut-prakan/bang-phli', to: '/samut-prakan/singlehome/bang-phli', statusCode: 301 },
	// 	{ from: '^/samut-prakan/bangna-trad', to: '/samut-prakan/singlehome/bangna-trad', statusCode: 301 },
	// 	{ from: '^/samut-prakan/phraeksa', to: '/samut-prakan/singlehome/phraeksa', statusCode: 301 },
	// 	{ from: '^/samut-prakan/bangpu', to: '/samut-prakan/singlehome/bangpu', statusCode: 301 },
	// 	{ from: '^/samut-prakan/phra-pradaeng', to: '/samut-prakan/singlehome/phra-pradaeng', statusCode: 301 },
	// 	{ from: '^/samut-prakan/phra-samut-chedi', to: '/samut-prakan/singlehome/phra-samut-chedi', statusCode: 301 },
	// 	{ from: '^/samut-prakan/bearing', to: '/samut-prakan/singlehome/bearing', statusCode: 301 },
	// 	{ from: '^/samut-prakan/lasalle', to: '/samut-prakan/singlehome/lasalle', statusCode: 301 },
	// 	{ from: '^/samut-prakan/samrong', to: '/samut-prakan/singlehome/samrong', statusCode: 301 },
	// 	{ from: '^/samut-prakan/bang-bo', to: '/samut-prakan/singlehome/bang-bo', statusCode: 301 },
	// 	{ from: '^/samut-prakan/poo-chao-saming-prai', to: '/samut-prakan/singlehome/poo-chao-saming-prai', statusCode: 301 },
	// 	{ from: '^/samut-prakan/bang-sao-thong', to: '/samut-prakan/singlehome/bang-sao-thong', statusCode: 301 },
	// 	{ from: '^/samut-prakan/pracha-uthit', to: '/samut-prakan/singlehome/pracha-uthit', statusCode: 301 }
	// ],
	/*
	 ** Nuxt.js dev-modules
	 */
	buildModules: [
		'~/modules/routes.js',
		'@nuxtjs/vuetify'
	],
	/*
	 ** Nuxt.js modules
	 */
	modules: [
		// '@nuxtjs/redirect-module',
		'@nuxtjs/gtm',
		[
			'nuxt-facebook-pixel-module', {
				track: 'PageView',
				pixelId: '178903360146871',
				disabled: false
			},
		],
		[
			'@nuxtjs/firebase',
			{
				// config: { // Dev only
				// 	apiKey: 'AIzaSyCgBUJHuD-PeiGvkSwjzX3wJBtfmisByKo',
				// 	authDomain: 'tb-co-th.firebaseapp.com',
				// 	databaseURL: 'https://tb-co-th.firebaseio.com',
				// 	projectId: 'tb-co-th',
				// 	storageBucket: 'tb-co-th.appspot.com',
				// 	messagingSenderId: '893633296815',
				// 	appId: '1:893633296815:web:494cd41bef2d20fdadd75a',
				// 	measurementId: 'G-BZVW07KCNN'
				// },
				config: { // Production only
					apiKey: 'AIzaSyDIT7IWYAmsxsFZXdz07udcjspQ-N2EEUM',
					authDomain: 'tb-co-th-263110.firebaseapp.com',
					databaseURL: 'https://tb-co-th-263110.firebaseio.com',
					projectId: 'tb-co-th-263110',
					storageBucket: 'tb-co-th-263110.appspot.com',
					messagingSenderId: '314789490062',
					appId: '1:314789490062:web:7fe942f058a407b65c88df',
					measurementId: 'G-JF62M826QS'
				},
				services: {
					firestore: true,
					realtimeDb: true,
					functions: {
						// location: 'us-central1',
						// emulatorPort: 5001,
						// emulatorHost: 'http://localhost',
					}
				}
			}
		]
	],
	/**
	 * GTM
	 */
	gtm: {
		id: 'GTM-N4PV39R',
		enabled: true, // TRUE: Always send real GTM events (also when using `nuxt dev`)
		debug: false,
		variables: {},
		pageTracking: false, // TRUE: May cause double events when using alongside with Google Analytics
	},
	publicRuntimeConfig: {
		gtm: {
			id: process.env.GOOGLE_TAG_MANAGER_ID
		}
	},
	/*
	 ** vuetify module configuration
	 ** https://github.com/nuxt-community/vuetify-module
	 */
	vuetify: {
		icons: { iconfont: 'mdi' },
		theme: { disable: true }
	},
	/*
	 ** Build configuration
	 */
	build: {
		sourcemap: true,
		/*
		 ** You can extend webpack config here
		 */
		extend(config, ctx) {
			config.devtool = 'source-map'
			if (ctx.isClient) {
				// config.devtool = 'source-map'

				// Run ESLint on save
				if (ctx.isDev) {
					config.module.rules.push({
						enforce: 'pre',
						test: /\.(js|vue)$/,
						loader: 'eslint-loader',
						exclude: /(node_modules)/
					})
				}
			}
		},
		// transpile: ['google-maps'],
		extractCSS: true,
		// publicPath: `/_${version}/`
		publicPath: '/_/',
		filenames: {
			chunk: ({ isDev }) => isDev ? '[name].js' : `[name].v${version}.[contenthash:8].js`,
			css: ({ isDev }) => isDev ? '[name].css' : `css/[name].v${version}.[contenthash:8].css`,
		},
	},
	// hooks: {
	// 	render: {
	// 		resourcesLoaded(resources) {
	// 			const path = `/_${version}/`
	// 			resources.clientManifest && (resources.clientManifest.publicPath = path)
	// 			resources.modernManifest && (resources.modernManifest.publicPath = path)
	// 			resources.serverManifest && (resources.serverManifest.publicPath = path)
	// 		}
	// 	}
	// },
}
